module.exports = __webpack_public_path__ + "static/media/14.a78a16ae.jpg";